"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../../../../common/Button/Button"));
var ReactModal_1 = __importDefault(require("../../../../common/Modal/ReactModal"));
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var icons_1 = __importDefault(require("../../../../theme/icons"));
var layout_1 = __importDefault(require("../../../../theme/layout/layout"));
require("../Style/styles.sass");
var react_router_dom_1 = require("react-router-dom");
var Dashboard = function (_a) {
    var navigation = _a.navigation;
    var _b = (0, react_1.useState)(""), fileId = _b[0], setFileId = _b[1];
    var _c = (0, react_1.useState)(false), showModal = _c[0], setShowModal = _c[1];
    var organization = (0, org_hook_1.useOrg)().organization;
    var t = (0, react_i18next_1.useTranslation)().t;
    var history = (0, react_router_dom_1.useHistory)();
    var _d = (0, react_1.useState)({
        name: "",
        status: "",
        download_link: "#",
        created_at: "",
        updated_at: "",
        percent: 0,
    }), zipStatus = _d[0], setZipSatus = _d[1];
    var footer = function () {
        return (react_1.default.createElement("div", { style: { borderWidth: 1, alignSelf: "flex-end", background: "#000" } }, "this is footer"));
    };
    // const onDownloadClick = () => {
    //   getFileId();
    // };
    function ButtonGroup(name, icon, link) {
        return (react_1.default.createElement("a", { className: "dashboard-link", href: link },
            react_1.default.createElement("div", { className: "dashboard-link-background" },
                react_1.default.createElement(icons_1.default, { name: icon, width: 60, height: 60, className: "" })),
            react_1.default.createElement("div", { style: { marginTop: 5 }, className: "dashboard-title" }, name)));
    }
    return (react_1.default.createElement("div", { className: "login" },
        react_1.default.createElement(layout_1.default, { showFooter: true, FooterComponent: footer, style: {
                flex: 0.5,
                alignSelf: " flex-end",
                display: "flex",
                flexDirection: "column",
            } },
            react_1.default.createElement("div", { className: "logo-container" },
                react_1.default.createElement(icons_1.default, { height: 80, name: "logo", width: 80 }),
                react_1.default.createElement(icons_1.default, { className: "icon_black", height: 80, name: "financeCoachIcon", width: 220 })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "button-container" },
                    ButtonGroup(t("guide"), "usage", "/superadmin/guide"),
                    ButtonGroup(t("knowledge"), "education", "/superadmin/education")),
                react_1.default.createElement("div", { className: "button-container" },
                    ButtonGroup(t("monitoring"), "myFinance", "/superadmin/myFinance"),
                    ButtonGroup(t("services"), "service", "/superadmin/service")),
                react_1.default.createElement("div", { style: {
                        display: "flex",
                        justifyContent: "center",
                    } },
                    react_1.default.createElement(Button_1.default, { className: "form-buttom", icon: react_1.default.createElement(icons_1.default, { name: "zip", className: "icon", height: 30, width: 30 }), 
                        // onClick={() => onClickZip()}
                        style: { width: 150, color: "white", marginRight: 2 }, text: t("Download File") }),
                    react_1.default.createElement(ReactModal_1.default, { title: t("Download File"), isOpen: showModal, modalCardStyle: { width: "50%" }, isClose: function () { return setShowModal(false); }, onSaveClick: function () { return setShowModal(false); }, showSaveButton: false, labelSaveButton: t("Update Zip"), saveIconName: "zip" }))))));
};
exports.default = Dashboard;
